import { CommonError } from '@com-delta-idp/mnx-utils';

export interface ApplyOfferResponse {
  /** purpa-nolin for not-logged-In & purpa-lin for logged-In  */
  acqExperience?: string;
  /** Offer id  */
  acquisitionOfferId: string;
  /** One time session token */
  acquisitionWebToken: string;
  /** Applicant request token */
  applicantRequestToken?: string;
  /** Apply offer url passed in the request */
  applyURL: string;
  /** Response error */
  error?: CommonError | null;
  /** Response status ['SUCCESS', 'FAIL', 'PARTIAL'] */
  status: string;
}

export interface OfferModalConfig {
  pageId: string;
  postPage: string;
  returnUrl: string;
  /** Where the component is being used: desktop web or mobile web*/
  channel: string;
  /** The card type that is being offered:
   * * GOLD
   * * BLUE
   * * PLATINUM
   * * RESERVE
   */
  card: string;
}

export interface PartnerContentModal {
  values: ApplyOfferResponse;
  config: OfferModalConfig;
}
